import * as React from "react";
import { ProviderLogin } from "../providerLogin";
import { Registration } from "./registration";
import { Login } from "./login";
import { useAppSelector } from "../../../store/hooks";
import { selectIsLoggedIn } from "../../../store/userSlice";

const NOT_SET = "notset";

export const MarketplaceProviderAWS: React.FC = () => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  function getCustomerIdentifier() {
    const key = `customerIdentifier=`;
    try {
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || NOT_SET;
    } catch (e) {
      return NOT_SET;
    }
  }
  const [customerIdentifier] = React.useState(getCustomerIdentifier());
  function getAwsAccountId() {
    const key = `awsAccountId=`;
    try {
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || NOT_SET;
    } catch (e) {
      return NOT_SET;
    }
  }
  const [awsAccountId] = React.useState(getAwsAccountId());
  function getProviderId() {
    try {
      const key = `providerId=`;
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || NOT_SET;
    } catch (e) {
      return NOT_SET;
    }
  }
  const [providerId] = React.useState(getProviderId());
  function getBillingAccountId() {
    try {
      const key = `accountId=`;
      const value = window.location.search
        .split(`?`)[1]
        .split(`&`)
        .find((i) => i.startsWith(key))
        ?.split(key)[1];
      return value || "";
    } catch (e) {
      return "";
    }
  }
  const [accountId] = React.useState(getBillingAccountId());
  const [isCustomer] = React.useState(!!getBillingAccountId());

  return (
    <>
      <div
        className="marketplace-provider marketplace-provider-aws enable-overflow w-full flex justify-center pt-16"
        style={{ minHeight: `100vh` }}
      >
        <div>
          <div>
            {isLoggedIn ? (
              isCustomer ? (
                <Login awsAccountId={awsAccountId!} providerId={providerId!} billingAccountId={accountId!} />
              ) : (
                <Registration
                  awsAccountId={awsAccountId!}
                  providerId={providerId!}
                  customerIdentifier={customerIdentifier!}
                />
              )
            ) : (
              <ProviderLogin isCustomer={isCustomer} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
